import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { styled, useA11yKeyEvent, useEventCallback, useThemeProps, } from '../../../foundation';
import { IconButtonGroupStyle } from './styles';
var _RcIconButtonGroup = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcIconButtonGroup' });
    var children = props.children, isStopPropagation = props.isStopPropagation, onClick = props.onClick, onKeyUp = props.onKeyUp, gap = props.gap, space = props.space, radius = props.radius, _a = props.component, Component = _a === void 0 ? 'div' : _a, rest = __rest(props, ["children", "isStopPropagation", "onClick", "onKeyUp", "gap", "space", "radius", "component"]);
    var clickHandler = useEventCallback(function (event) {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        isStopPropagation && event.stopPropagation();
    });
    var handleOnKeyUp = useA11yKeyEvent(clickHandler, {
        preventDefault: false,
    });
    /** that button bar just for put buttons inside, and can stop below all events from this bar layer. */
    var keyUpHandler = useEventCallback(function (event) {
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(event);
        isStopPropagation && event.stopPropagation();
        handleOnKeyUp(event);
    });
    return (React.createElement(Component, __assign({ onClick: clickHandler, onKeyUp: keyUpHandler, ref: ref }, rest), children));
});
/**
 * provide IconButton group with wrapper
 */
var RcIconButtonGroup = styled(_RcIconButtonGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), IconButtonGroupStyle);
RcIconButtonGroup.defaultProps = {
    gap: 0,
    direction: 'horizontal',
};
RcIconButtonGroup.displayName = 'RcIconButtonGroup';
export { RcIconButtonGroup };
var templateObject_1;
